import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build/80754af9/repo/apps/quales-web/components/composites/LoginComposite.tsx");
